import script from "./DevolucionCreate.vue?vue&type=script&setup=true&lang=js"
export * from "./DevolucionCreate.vue?vue&type=script&setup=true&lang=js"

import "./DevolucionCreate.vue?vue&type=style&index=0&id=14511a64&scoped=true&lang=css"

import exportComponent from "/home/runner/work/jeanInformatico-management-system/jeanInformatico-management-system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14511a64"]])

export default __exports__